import React from 'react'
import type { AthleteProps, LeagueProps } from '../types'
import { Button, Text, View } from './Themed'
import { useColors } from '../constants/useColors'
import { AthleteImage } from './Jerseys'


type AthleteLozengeProps = {
    leagues:LeagueProps[],
    athlete: AthleteProps,
    is_active?:boolean,
    abbr_only?:boolean,
    text_size?:number,
    onSelect: (athlete:AthleteProps) => void
}
export const AthleteLozenge = ({ leagues, athlete, text_size, is_active, abbr_only, onSelect }:AthleteLozengeProps) => {
    const Colors = useColors();
    const league = leagues.find(l => l.league_id == athlete.league_id);
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(athlete)
    }
    
    return (
        <Button float 
            style={{ flexGrow:1, flexDirection:'row', alignItems:'center', margin:4, borderWidth:1, borderRadius:100, padding:0, borderColor:is_active ? Colors.text.success : Colors.borders.light }} onPress={() => handleSelect()}>
            {abbr_only ?
            <View transparent style={{ padding:10 }}>
                <Text size={text_size??16}  theme='h2' color={is_active ? Colors.text.success : undefined}>{athlete.position}: {athlete.abbr_name}</Text>
            </View>
            :
            <View transparent style={{ flexDirection:'row', padding:2 }}>
                <AthleteImage
                    athlete={athlete}
                    league={league}
                    size={(text_size ?? 16) * 2}
                    number_size={8}
                    
                />
                <View transparent style={{marginLeft:10, marginRight:10}}>
                    <Text size={text_size??16} theme='h2' color={is_active ? Colors.text.success : undefined}>{athlete.abbr_name}</Text>
                    {athlete.team ?
                    <Text style={{ marginTop:3 }} size={10} color={is_active ? Colors.text.success : undefined}>{league?`${league.league_name}: `:''}{athlete.team.abbr}</Text>
                    :<></>}
                </View>
            </View>
            }
        </Button>
    )
}

export default AthleteLozenge